<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2>Neighbourhoods List</h2> <router-link class="btn btn-secondary btn-sm" :to="{name:'neighbourhoods.create'}">Create New</router-link> 
            </div>
        </div>

        <div class="row justify-content-center mt-4">
            <table class="table table-hover">
                <thead>
                    <tr><th scope="col">#</th> <th scope="col">Neighbourhood</th> <th scope="col">LPA</th> <th scope="col">Actions</th></tr>
                </thead> 
                <tbody>
                    <tr v-for="neighbourhood in neighbourhoods" :key="neighbourhood.id">
                        <th scope="row">{{neighbourhood.id}}</th> 
                        <td>{{neighbourhood.name}}</td> 
                        <td>{{neighbourhood.lpa_name}}</td> 
                        <td>
                            <div class="btn-group">
                                <router-link :to="{name: 'neighbourhoods.edit', params:{id: neighbourhood.id}}" class="btn btn-default py-0 px-1" v-tooltip="'Edit'">
                                    <img src="../../../assets/svgs/Edit-Icon.svg">
                                </router-link>
                                <router-link v-if="currentUser.can('delete-neighbourhoods')" :to="{name: 'neighbourhoods.delete', params: {id: neighbourhood.id}}" class="btn btn-default py-0 px-1"  v-tooltip="'Delete'">
                                    <img src="../../../assets/svgs/Delete-Icon.svg">
                                </router-link>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import CurrentUser from '../../../mixins/CurrentUser';

export default {
    mixins: [CurrentUser],

    mounted() {
        this.$store.dispatch('lpas/fetch');
        this.$store.dispatch('neighbourhoods/fetch');
    },

    computed: {
        neighbourhoods: function () {
            var lpa_ids = this.lpas.map(lpa => lpa.id);
            return this.$store.state.neighbourhoods.data.filter(neighbourhood => lpa_ids.includes(neighbourhood.lpa_id));
        },
        lpas: function () {
            return this.$store.state.lpas.data.filter(lpa => lpa.force_id === this.currentUser.force_id);
        }
    }
}
</script>